import { MaskHappyIcon } from "@phosphor-icons/react";
import { CSSProperties } from "react";

type TheatreMasksIconProps = {
  size?: number;
  color?: CSSProperties["color"];
  crossed?: boolean;
};

export const TheatreMasksIcon = ({
  size = 32,
  color = "currentColor",
  crossed = false,
}: TheatreMasksIconProps) => {
  const maskSize = size * 0.78;
  const strokeWidth = Math.max(4, size * 0.08);
  return (
    <span
      style={{
        position: "relative",
        display: "inline-block",
        width: size,
        height: size,
        verticalAlign: "middle",
      }}
    >
      <MaskHappyIcon
        size={maskSize}
        color={color}
        style={{
          position: "absolute",
          left: 0,
        }}
      />
      {crossed && (
        <svg
          width={maskSize + 2}
          height={maskSize + 2}
          viewBox="0 0 100 100"
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            pointerEvents: "none",
            overflow: "visible",
          }}
        >
          <line
            x1="10"
            y1="90"
            x2="90"
            y2="10"
            stroke="white"
            strokeWidth={strokeWidth * 2}
            strokeLinecap="round"
          />
          <line
            x1="10"
            y1="90"
            x2="90"
            y2="10"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
        </svg>
      )}
    </span>
  );
};

export const MicrophoneIcon = ({
  fillColor,
  style,
}: {
  fillColor: CSSProperties["color"];
  style: CSSProperties;
}) => {
  return (
    <svg
      style={style}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1197_3088)">
        <path
          d="M42.9683 31.3018C42.9683 30.39 42.2291 29.6509 41.3174 29.6509C40.4056 29.6509 39.6665 30.39 39.6665 31.3018C39.6665 37.6741 34.4328 42.8585 27.9998 42.8585C21.5667 42.8585 16.3331 37.6742 16.3331 31.3018C16.3331 30.39 15.5939 29.6509 14.6822 29.6509C13.7704 29.6509 13.0312 30.39 13.0312 31.3018C13.0312 39.0389 19.0094 45.2637 26.3489 46.0692V49.4622H21.286C20.3742 49.4622 19.6351 50.2014 19.6351 51.1131C19.6351 52.0249 20.3742 52.764 21.286 52.764H34.7137C35.6255 52.764 36.3647 52.0249 36.3647 51.1131C36.3647 50.2014 35.6255 49.4622 34.7137 49.4622H29.6509V46.0692C36.9938 45.2634 42.9683 39.0351 42.9683 31.3018Z"
          fill={fillColor}
        />
        <path
          d="M27.9976 3.23584C23.4339 3.23584 19.6328 6.92681 19.6328 11.4906V31.302C19.6328 35.8657 23.4338 39.5568 27.9976 39.5568C32.5612 39.5568 36.3624 35.8659 36.3624 31.302V11.4906C36.3624 6.92703 32.5615 3.23584 27.9976 3.23584ZM33.0605 31.302C33.0605 33.9868 30.7419 36.2548 27.9976 36.2548C25.2533 36.2548 22.9347 33.9867 22.9347 31.302V11.4906C22.9347 8.80576 25.2533 6.53776 27.9976 6.53776C30.7419 6.53776 33.0605 8.80587 33.0605 11.4906V31.302Z"
          fill={fillColor}
        />
        <path
          d="M50.6777 5.73695C50.033 5.09229 48.9876 5.09219 48.3429 5.73695C47.6982 6.38172 47.6982 7.42701 48.3429 8.07178C51.1493 10.8781 52.695 14.6095 52.695 18.5783C52.695 22.5472 51.1495 26.2786 48.3429 29.085C47.6982 29.7297 47.6982 30.7751 48.3429 31.4197C48.9876 32.0646 50.033 32.0646 50.6777 31.4198C54.1078 27.9896 55.9968 23.4292 55.9968 18.5783C55.9968 13.7275 54.1078 9.16695 50.6777 5.73695Z"
          fill={fillColor}
        />
        <path
          d="M46.0058 10.4098C45.3611 9.76511 44.3157 9.76511 43.6711 10.4098C43.0263 11.0545 43.0263 12.0998 43.6711 12.7445C45.2323 14.3056 46.092 16.3775 46.092 18.5783C46.092 20.7792 45.2322 22.8509 43.6711 24.4122C43.0263 25.0572 43.0263 26.1024 43.6711 26.7472C44.3157 27.392 45.361 27.392 46.0058 26.7472C48.1907 24.5623 49.3939 21.6614 49.3939 18.5785C49.3938 15.4956 48.1906 12.5946 46.0058 10.4098Z"
          fill={fillColor}
        />
        <path
          d="M41.3416 15.0777C40.697 14.433 39.6516 14.4331 39.0069 15.0779C38.3621 15.7226 38.3624 16.7679 39.0071 17.4126C39.3197 17.7252 39.4919 18.1393 39.4919 18.5786C39.4919 19.018 39.3197 19.4322 39.007 19.7448C38.3624 20.3896 38.3622 21.4349 39.0069 22.0795C39.6519 22.7245 40.6973 22.7242 41.3417 22.0796C42.2781 21.1434 42.7937 19.9 42.7937 18.5786C42.7937 17.2573 42.2779 16.0139 41.3416 15.0777Z"
          fill={fillColor}
        />
        <path
          d="M3.30192 18.5783C3.30192 14.6095 4.84739 10.8782 7.65395 8.07178C8.29872 7.42701 8.29872 6.38172 7.65395 5.73695C7.00919 5.09229 5.96389 5.09219 5.31923 5.73695C1.88902 9.16695 0 13.7275 0 18.5783C0 23.4291 1.88902 27.9897 5.31912 31.4197C5.96378 32.0645 7.0093 32.0645 7.65384 31.4197C8.29861 30.775 8.29861 29.7297 7.65384 29.0849C4.84739 26.2787 3.30192 22.5472 3.30192 18.5783Z"
          fill={fillColor}
        />
        <path
          d="M9.90348 18.5784C9.90348 16.3776 10.7633 14.3058 12.3244 12.7446C12.9692 12.0998 12.9692 11.0545 12.3244 10.4098C11.6797 9.76508 10.6343 9.76508 9.98967 10.4098C7.8048 12.5946 6.60156 15.4957 6.60156 18.5784C6.60156 21.6611 7.8048 24.5622 9.98967 26.747C10.6343 27.3917 11.6798 27.3917 12.3244 26.747C12.9692 26.1022 12.9692 25.0569 12.3244 24.4122C10.7634 22.8511 9.90348 20.7792 9.90348 18.5784Z"
          fill={fillColor}
        />
        <path
          d="M16.9976 19.7445C16.685 19.4318 16.5128 19.0176 16.5128 18.5783C16.5128 18.1389 16.6849 17.7248 16.9975 17.4121C17.6424 16.7674 17.6424 15.722 16.9976 15.0774C16.353 14.4326 15.3077 14.4325 14.6629 15.0773C13.7265 16.0136 13.2109 17.2569 13.2109 18.5783C13.2109 19.8996 13.7265 21.143 14.6629 22.0792C15.3075 22.724 16.3531 22.724 16.9976 22.0792C17.6424 21.4346 17.6424 20.3893 16.9976 19.7445Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1197_3088">
          <rect width="56" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
